import { useEffect, useState } from 'react';
import { motion } from 'motion/react';
import { BellRing } from 'lucide-react';

function visualStatus(table) {
  const activeOrders = table.stats?.activeOrders || 0;
  const pendingOrders = table.stats?.pendingOrders || 0;
  if (table.status === 'open_requested') return 'requested';
  if (!table.active) return 'inactive';
  if (table.status === 'needs_attention' || pendingOrders > 0) return 'urgent';
  if (activeOrders > 0) return 'busy';
  return 'open';
}

function priorityTier(requestedAt) {
  if (!requestedAt) return 'low';
  const mins = Math.floor((Date.now() - new Date(requestedAt).getTime()) / 60000);
  if (mins >= 5) return 'high';
  if (mins >= 3) return 'mid';
  return 'low';
}

export default function ServiceMesaButton({ table, layout, selected, onSelect }) {
  const status = visualStatus(table);
  const isRequested = status === 'requested';

  // Recalcular prioridad cada 30s (reactivo al tiempo)
  const [priority, setPriority] = useState(() => priorityTier(table?.openRequest?.requestedAt));
  useEffect(() => {
    if (!isRequested) return;
    const recalc = () => setPriority(priorityTier(table?.openRequest?.requestedAt));
    recalc();
    const id = setInterval(recalc, 30000);
    return () => clearInterval(id);
  }, [isRequested, table?.openRequest?.requestedAt]);

  const minsAgo = isRequested && table?.openRequest?.requestedAt
    ? Math.floor((Date.now() - new Date(table.openRequest.requestedAt).getTime()) / 60000)
    : 0;

  return (
    <motion.button
      type="button"
      className={`service-table service-table-${status} ${selected ? 'is-selected' : ''}`}
      data-priority={isRequested ? priority : undefined}
      style={{
        left: `${layout.x}%`,
        top: `${layout.y}%`,
        width: `${layout.w}%`,
        height: `${layout.h}%`,
        transform: `rotate(${layout.rotation || 0}deg)`
      }}
      onClick={() => onSelect(table)}
      animate={isRequested && priority === 'high' ? { scale: [1, 1.03, 1] } : {}}
      transition={isRequested && priority === 'high'
        ? { duration: 1.2, repeat: Infinity, ease: 'easeInOut' }
        : { duration: 0.2 }}
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
    >
      <strong>M{table.number}</strong>
      {isRequested ? (
        <>
          <span className="service-table-req-label">Solicita apertura</span>
          <em className="service-table-req-badge">
            <BellRing size={11} />
            {minsAgo > 0 ? `${minsAgo}'` : 'ahora'}
          </em>
        </>
      ) : (
        <>
          <span>{table.active ? `${(table.stats?.total || 0).toFixed(2)} €` : 'Cerrada'}</span>
          {(table.stats?.pendingOrders || 0) > 0 && <em>{table.stats.pendingOrders}</em>}
        </>
      )}
    </motion.button>
  );
}
